// GENERATED FILE - do not edit.
// Emitted by tools/generate-wire-schemas.mjs from
// Server/src/Shared/Server/Resources/openapi.json (the spec lockfile).
// Regenerate with: npm run generate:wire
//
// Base wire shape for the server "ChatRegressionGroupResult" component. The corresponding
// *.schema.ts is the facade that names it (and hosts any future refinement);
// see design/wiki/wire-schemas.md.
import { z } from "zod";
import { ChatRegressionShortlistRecallGenShape } from "./chat-regression-shortlist-recall.gen";
import { ChatRegressionJudgeAgreementGenShape } from "./chat-regression-judge-agreement.gen";
import { ChatRegressionClarifierMetricsGenShape } from "./chat-regression-clarifier-metrics.gen";

export const ChatRegressionGroupResultGenShape = z.strictObject({
  groupId: z.string(),
  groupName: z.string(),
  requiredForPromotion: z.boolean(),
  passThreshold: z.number(),
  caseCount: z.number(),
  passCount: z.number(),
  passRate: z.number(),
  passed: z.boolean(),
  shortlistRecall: ChatRegressionShortlistRecallGenShape,
  judgeAgreement: ChatRegressionJudgeAgreementGenShape,
  clarifierMetrics: ChatRegressionClarifierMetricsGenShape,
});
